import utils from 'utils';
'use strict';

class SearchResult {
  constructor(elem) {
    this.elem = elem;
    
    this.defaultViewMode = this.elem.dataset.defaultViewMode;
    this.mapToggleBtn = this.elem.querySelector('.js-search-results-map-toggle');

    this.searchHeader = this.elem.querySelector('.search-results-header');
    this.stickyFooter = this.elem.querySelector('.search-results-sticky-nav');

    this.searchEngineCloseBtn = this.elem.querySelector('.js-search-engine-close');
    this.searchEngineOpenBtn = this.elem.querySelectorAll('.js-search-engine-open');

    this.searchFiltersCloseBtn = this.elem.querySelector('.js-search-filters-close');
    this.searchFiltersOpenBtn = this.elem.querySelectorAll('.js-search-filters-open');

    this.searchEngine = this.elem.querySelector('.search-engine');
    this.searchFilters = this.elem.querySelector('.search-filters');
    this.searchFiltersTags = this.elem.querySelectorAll('.search-results-features-filters [data-selected-feature]');

    this.sortSelect = this.elem.querySelector('.search-sort > select');

    this.triggerFiltersTags = this.switchFilterTags.bind(this);
    this.events();
  }

  handleSticky() {
    utils.isInViewport(this.searchHeader, e => {
      if (e.isIntersecting) {
        this.stickyFooter.classList.remove('active');
      } else {
        this.stickyFooter.classList.add('active');
      }
    });
  }

  events() {
    this.handleSticky();

    if(this.defaultViewMode === 'map' && this.mapToggleBtn) {
      this.mapToggleBtn.click();
    }

    this.searchEngineCloseBtn.addEventListener('click', e => {
      this.close(this.searchEngine);
    });

    this.searchFiltersCloseBtn.addEventListener('click', e => {
      this.close(this.searchFilters);
    });

    for (let btn of this.searchEngineOpenBtn) {
      btn.addEventListener('click', e => {
        e.preventDefault();
        this.open(this.searchEngine);
      });
    }

    for (let btn of this.searchFiltersOpenBtn) {
      btn.addEventListener('click', e => {
        this.open(this.searchFilters);
      });
    }

    utils.mq.md.addListener(e => {
      if (e.matches) {
        this.close(this.searchEngine);
        this.close(this.searchFilters);
      }
    });

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', () => {
        const results = this.elem.querySelectorAll('.search-results-village');
        results.forEach((result) => {
          const gallerySlider = result.querySelector('.search-results-village-gallery .splide');
          if (gallerySlider) {
            /* TODO : remount slider after sorting */
          }
        });
      });
    }

    this.handleFilterTags(this.searchFiltersTags);
    document.addEventListener('reloadFiltersTags', (e) => {
      this.handleFilterTags(e.detail.wrapper.querySelectorAll('.search-results-features-filters [data-selected-feature]'));
    });
    
  }

  handleFilterTags(searchFiltersTags) {
    if (searchFiltersTags) {
      searchFiltersTags.forEach((searchFiltersTag) => {
        searchFiltersTag.removeEventListener('click', this.triggerFiltersTags);
        searchFiltersTag.addEventListener('click', this.triggerFiltersTags);
      });
    }
  }

  switchFilterTags(event) {
    const filtersTargetValue = event.target.dataset.selectedFeature;
    const filterTarget = this.searchFilters.querySelector(`[data-filter-feature="${filtersTargetValue}"]`);

    // filterTarget.click();
    filterTarget.checked = !filterTarget.checked;
    filterTarget.dispatchEvent(new Event('change'));
  }

  close(elem) {
    elem.classList.remove('active');
    document.documentElement.style.overflow = 'auto';
  }

  open(elem) {
    elem.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
  }
}


if (document.querySelector('.search-results-page')) {
  const searchResult = new SearchResult(document.querySelector('.search-results-page'));
}
